// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   // serverUrl: 'http://10.10.50.196:8019/api/',
//   serverUrl: 'https://localhost:44370/api/',
//   envName: 'DEV',
//   captchaKey:'6LePXzcqAAAAAELCdbRglXDSQqAUpgWmzfHidYfB',
//   secretCaptchaKey:'6LePXzcqAAAAAC2r1EXp80vVNSmWlhk7QQPLbisY'
// };



export const environment = {
  production: true,
  serverUrl: 'https://canaldenuncia.amf.cl/api/',
  captchaKey:'6LePXzcqAAAAAELCdbRglXDSQqAUpgWmzfHidYfB'
};




